import React from 'react'
import { Link } from "react-router-dom";

function PageNotFound() {
    return (
        <div>
            <div>PageNotFound :D</div>
            <Link to="/home" >Page d'accueil</Link>
        </div>

    )
}

export default PageNotFound